/* Mimi Shape product page: options → variant, pre-selection from saved measurements,
   add to cart (with measurements as line-item properties), gallery dots, sticky bar,
   two-size videos, size table highlight, complementary product. */
(() => {
  const Mimi = (window.Mimi = window.Mimi || {});
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Finder hook (Stage 3 provides Mimi.openFinder) ---------- */
  Mimi.requestFinder = (detail = {}) => {
    if (typeof Mimi.openFinder === 'function') return Mimi.openFinder(detail);
    // Until the finder exists: take her to the size buttons
    const first = $('[data-m-buy] .m-sizes__input:not([disabled])');
    if (first) { first.closest('fieldset').scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' }); first.focus({ preventScroll: true }); }
  };

  /* ---------- Buy block ---------- */
  const buy = $('[data-m-buy]');
  const data = buy && JSON.parse($('[data-m-product-json]').textContent);
  Mimi.product = data || null;

  const measurementProps = (chart) => Mimi.measurementProps(chart);

  if (buy && data) {
    const form = $('[data-m-form]', buy);
    const idInput = $('[data-m-variant-id]', form);
    const price = $('[data-m-price]', buy);
    const button = $('[data-m-main-button]', buy);
    const error = $('[data-m-error]', buy);
    const note = $('[data-m-by-measurements]', buy);
    const optionCount = data.optionNames.length;

    // Options with a single value are fixed (e.g. one colour) and have no radios
    const fixed = data.variants[0].options.map((_, i) => {
      const vals = new Set(data.variants.map((v) => v.options[i]));
      return vals.size === 1 && i !== data.sizeIndex ? [...vals][0] : null;
    });

    const selected = () => {
      const sel = [];
      for (let i = 0; i < optionCount; i++) {
        if (fixed[i] !== null) { sel[i] = fixed[i]; continue; }
        const r = $(`[data-m-option="${i}"] .m-sizes__input:checked`, form);
        sel[i] = r ? r.value : null;
      }
      return sel;
    };
    const variantFor = (sel) => sel.every((v) => v !== null) ? data.variants.find((v) => v.options.every((o, i) => o === sel[i])) : null;

    let viaMeasurements = false;
    const update = (fromUser) => {
      const sel = selected();
      const v = variantFor(sel);
      sel.forEach((val, i) => {
        const label = $(`[data-m-option-label="${i}"]`, form);
        if (label) label.textContent = val ? data.strings.optionSelected.replace('__NAME__', data.optionNames[i]).replace('__VALUE__', val) : data.optionNames[i];
      });
      if (fromUser) viaMeasurements = false;
      if (note) {
        note.hidden = !(viaMeasurements && v);
        if (v) note.textContent = note.dataset.template.replace('__SIZE__', sel[data.sizeIndex]);
      }
      idInput.value = v ? v.id : '';
      price.textContent = v ? v.price : data.variants[0].price;
      // Copy v3: "בחירת מידה" until a size is picked, then "הוספה לסל"
      button.textContent = v ? data.strings.add : data.strings.choose;
      error.hidden = true;
      if (v && fromUser) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(history.state, '', url);
      }
      Mimi.currentVariant = v || null;
      document.dispatchEvent(new CustomEvent('mimi:variant', { detail: { variant: v, size: data.sizeIndex >= 0 ? sel[data.sizeIndex] : null } }));
    };

    form.addEventListener('change', (e) => { if (e.target.matches('.m-sizes__input')) update(true); });

    // Pre-select from saved finder measurements (doc 2.2 #6, 3.2 "זיכרון")
    const preselect = () => {
      if (data.sizeIndex < 0 || new URL(location.href).searchParams.get('variant')) return;
      const values = Mimi.measurements && Mimi.measurements.get();
      if (!values) return;
      const size = Mimi.recommendSize(data.chart, values);
      if (!size) return;
      const input = $$(`[data-m-option="${data.sizeIndex}"] .m-sizes__input`, form).find((i) => i.value === size && !i.disabled);
      if (!input) return;
      input.checked = true;
      viaMeasurements = true;
      update(false);
    };
    preselect();
    update(false);
    document.addEventListener('mimi:measurements', (e) => {
      if (!e.detail) { viaMeasurements = false; update(false); return; } // "למחוק את המידות שלי"
      preselect();
    });

    // Select a size from outside (finder result: "לבחור M ולחזור למוצר")
    Mimi.selectSize = (size, byMeasurements = true) => {
      const input = $$(`[data-m-option="${data.sizeIndex}"] .m-sizes__input`, form).find((i) => i.value === size && !i.disabled);
      if (!input) return false;
      input.checked = true; viaMeasurements = byMeasurements; update(false);
      return true;
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const v = variantFor(selected());
      if (!v) {
        // "בחרי מידה, או בדקי איזו מידה מתאימה לך": take her to the sizes
        error.textContent = data.strings.noSize; error.hidden = false;
        const first = form.querySelector('.m-sizes__input:not([disabled])');
        if (first) { first.closest('fieldset').scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' }); first.focus({ preventScroll: true }); }
        return;
      }
      button.setAttribute('aria-busy', 'true');
      try {
        await Mimi.addToCart([{ id: v.id, quantity: 1, properties: measurementProps(data.chart) }]);
      } catch (err) {
        error.textContent = data.strings.error; error.hidden = false;
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  }

  /* ---------- Gallery dots ---------- */
  $$('[data-m-gallery]').forEach((gallery) => {
    const track = $('[data-m-gallery-track]', gallery);
    const dots = $$('.m-gallery__dot', gallery);
    if (!dots.length) return;
    const slides = () => [...track.children];
    const setActive = (i) => {
      dots.forEach((d, j) => { d.classList.toggle('is-active', j === i); if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      gallery.classList.toggle('has-caption', !!slides()[i]?.classList.contains('has-caption'));
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > 0.6) setActive(slides().indexOf(en.target)); });
    }, { root: track, threshold: [0.6] });
    slides().forEach((s) => io.observe(s));
    setActive(0);
    dots.forEach((d, i) => d.addEventListener('click', () => {
      slides()[i].scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    }));
  });
  /* ---------- 2.9 Sticky bar ---------- */
  const sticky = $('[data-m-sticky]');
  const mainBtn = $('[data-m-main-button]');
  if (sticky && mainBtn) {
    const sPrice = $('[data-m-sticky-price]', sticky);
    const sSize = $('[data-m-sticky-size]', sticky);
    const sBtn = $('[data-m-sticky-btn]', sticky);
    const render = (detail) => {
      const v = detail && detail.variant;
      if (v) sPrice.textContent = v.price;
      sSize.textContent = detail && detail.size && v ? sSize.dataset.template.replace('__SIZE__', detail.size) : '';
      sBtn.textContent = v ? sBtn.dataset.labelAdd : sBtn.dataset.labelChoose;
    };
    render({ variant: Mimi.currentVariant, size: Mimi.currentVariant && Mimi.product ? Mimi.currentVariant.options[Mimi.product.sizeIndex] : null });
    document.addEventListener('mimi:variant', (e) => render(e.detail));
    sBtn.addEventListener('click', () => {
      if (Mimi.currentVariant) $('[data-m-form]').requestSubmit();
      else Mimi.requestFinder({ opener: sBtn });
    });
    // Visible only after the main button has scrolled out above the viewport. The observer covers
    // normal scrolling; the rAF-throttled scroll check covers fast flings that jump past the button.
    const setPast = (past) => {
      if (sticky.hidden === !past) return;
      sticky.hidden = !past;
      document.documentElement.classList.toggle('m-has-sticky', past);
    };
    new IntersectionObserver(([en]) => setPast(!en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainBtn);
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => { setPast(mainBtn.getBoundingClientRect().bottom < 0); ticking = false; });
    }, { passive: true });
  }

  /* ---------- 2.3 Videos: play while in view, pause button, expand ---------- */
  $$('[data-m-video]').forEach((fig) => {
    const video = $('video', fig);
    if (!video) return;
    const toggle = $('[data-m-video-toggle]', fig);
    const expand = $('[data-m-video-expand]', fig);
    let userPaused = reducedMotion; // reduced motion: never autoplay
    const sync = () => {
      if (!toggle) return;
      const playing = !video.paused;
      toggle.setAttribute('aria-pressed', String(!playing));
      toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
      fig.classList.toggle('is-paused', !playing);
    };
    video.addEventListener('play', sync); video.addEventListener('pause', sync); sync();
    if (toggle) toggle.addEventListener('click', () => {
      if (video.paused) { userPaused = false; video.play().catch(() => {}); } else { userPaused = true; video.pause(); }
    });
    if (expand) expand.addEventListener('click', () => {
      if (video.requestFullscreen) video.requestFullscreen().catch(() => {});
      else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
    });
    if (fig.hasAttribute('data-m-video-manual')) return;
    video.muted = true;
    new IntersectionObserver(([en]) => {
      if (en.isIntersecting && !userPaused) video.play().catch(() => {});
      else if (!en.isIntersecting) video.pause();
    }, { threshold: 0.5 }).observe(video);
  });

  /* ---------- "טבלת מידות" window (copy v7 1.2) ---------- */
  const chartDlg = $('[data-m-chart]');
  const chartOpen = $('[data-m-chart-open]');
  if (chartDlg && chartOpen) {
    chartOpen.addEventListener('click', () => {
      chartDlg.showModal();
      document.documentElement.classList.add('m-chart-open');
      $('#MimiChartTitle', chartDlg).focus({ preventScroll: true });
    });
    $('[data-m-chart-close]', chartDlg).addEventListener('click', () => chartDlg.close());
    chartDlg.addEventListener('click', (e) => { if (e.target === chartDlg) chartDlg.close(); });
    chartDlg.addEventListener('close', () => {
      document.documentElement.classList.remove('m-chart-open');
      if (!chartDlg.dataset.handoff) chartOpen.focus({ preventScroll: true });
      delete chartDlg.dataset.handoff;
    });
    // Last line: "לא בטוחה איזו מידה לבחור? לחצי כאן" → the finder (focus returns to "טבלת מידות")
    $('[data-m-chart-finder]', chartDlg).addEventListener('click', () => {
      chartDlg.dataset.handoff = '1';
      chartDlg.close();
      Mimi.requestFinder({ opener: chartOpen });
    });
  }

  /* ---------- Size tables (1.4 and the "טבלת מידות" window): highlight her row ---------- */
  const highlightRows = () => {
    if (!Mimi.product) return;
    const values = Mimi.measurements && Mimi.measurements.get();
    const mine = values ? Mimi.recommendSize(Mimi.product.chart, values) : null;
    $$('[data-m-size-guide] tr[data-size]').forEach((tr) => {
      const on = tr.dataset.size === mine;
      tr.classList.toggle('is-mine', on);
      if (on) tr.setAttribute('aria-current', 'true'); else tr.removeAttribute('aria-current');
    });
  };
  highlightRows();
  document.addEventListener('mimi:measurements', highlightRows);

  /* ---------- 2.7 Reviews filter label + state ---------- */
  $$('[data-m-reviews]').forEach((box) => {
    const mineBtn = $('[data-m-review-filter="mine"]', box);
    const allBtn = $('[data-m-review-filter="all"]', box);
    const size = Mimi.currentVariant && Mimi.product ? Mimi.currentVariant.options[Mimi.product.sizeIndex] : null;
    if (mineBtn) {
      if (size) mineBtn.textContent = mineBtn.dataset.template.replace('__SIZE__', size);
      else { mineBtn.hidden = true; allBtn.setAttribute('aria-pressed', 'true'); mineBtn.setAttribute('aria-pressed', 'false'); }
    }
    box.addEventListener('click', (e) => {
      const b = e.target.closest('[data-m-review-filter]');
      if (!b) return;
      $$('[data-m-review-filter]', box).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      box.dispatchEvent(new CustomEvent('mimi:review-filter', { bubbles: true, detail: { filter: b.dataset.mReviewFilter, size } }));
    });
  });
})();
